import { render } from "./Aboutme.vue?vue&type=template&id=1ca2a406&scoped=true"
import script from "./Aboutme.vue?vue&type=script&lang=js"
export * from "./Aboutme.vue?vue&type=script&lang=js"

import "./Aboutme.vue?vue&type=style&index=0&id=1ca2a406&scoped=true&lang=css"

import exportComponent from "D:\\portfolio\\bhavindabhi\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1ca2a406"]])

export default __exports__